<template>
  <div class="manage-requests"
       :class="classes">
    <manage-requests-header :show-ignore-btn="requests.length > 0"
                            @ignoreAll="ignoreAll" />

    <manage-requests-list v-if="requests.length"
                          :requests="requests" />

    <manage-requests-empty-screen v-else
                                  :loading="loading"
                                  @retry="retry" />
  </div>
</template>

<script>
  import ManageRequestsHeader from '@/components/Common/ManageRequests/ManageRequestsHeader'
  import ManageRequestsList from '@/components/Common/ManageRequests/ManageRequestsList'
  import ManageRequestsEmptyScreen from '@/components/Common/ManageRequests/ManageRequestsEmptyScreen'

  export default {
    components: {
      ManageRequestsHeader,
      ManageRequestsList,
      ManageRequestsEmptyScreen
    },

    data() {
      return {
        loading: false
      }
    },

    created() {
      this.$store.dispatch('requests/load', this.groupId)
    },

    computed: {
      ...mapGetters('requests', [
        'requests'
      ]),

      ...mapGetters('auth', {
        currentUser: 'currentUser'
      }),

      groupId() {
        return this.currentUser.group_id
      },

      classes() {
        return {
          'manage-requests-empty-page': !this.requests.length
        }
      }
    },

    methods: {
      ignoreAll() {
        this.showModal('requestAction', {
          request: null,
          action: 'ignoreAll'
        })
      },

      retry() {
        this.loading = true

        this.$store.dispatch('requests/load', this.groupId)
          .then(() => {
            this.loading = false
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
  .manage-requests {
    height: auto;
    width: 100%;

    padding: 40px 48px 40px 40px;

    &-empty-page {
      height: 100%;

      display: flex;
      flex-direction: column;
      justify-content: center;
    }
  }
</style>